import React, { useEffect, useState } from 'react';
import { CameraIcon, ChevronLeftIcon, ChevronRightIcon, XIcon } from 'lucide-react';
const EVENT_PHOTOS: (string | null)[] = ['https://cdn.magicpatterns.com/uploads/vEbELyvMch2ThAtivjXtwE/IMG_6854.png', 'https://cdn.magicpatterns.com/uploads/cz5sNiMiKAu1CFvjJWeKGL/IMG_8259.jpg', 'https://cdn.magicpatterns.com/uploads/fJM3KMVgZjrWQg64SdR9GM/IMG_8994.jpg', 'https://cdn.magicpatterns.com/uploads/4qJMQkYwqWvcpb1EZau99P/IMG_9158.jpg', 'https://cdn.magicpatterns.com/uploads/qa9zUcA9PJG3X5WvXcbZXi/WhatsApp_Image_2026-06-27_at_7.13.44_PM.jpg', 'https://cdn.magicpatterns.com/uploads/kVeV3DkjVZGURnMGgkb3KT/IMG_2839.jpg', 'https://cdn.magicpatterns.com/uploads/nUnV8DGZw65WCZ6DGUPFWJ/IMG_3441.jpg', 'https://cdn.magicpatterns.com/uploads/bMSvWh9geiWK2GKviGkfsN/IMG_5402.jpg', 'https://cdn.magicpatterns.com/uploads/dfzqRohjm2CBSxEyhrNsdm/IMG_6581.png', 'https://cdn.magicpatterns.com/uploads/uziVQyFVnpV4x9idfoDgPP/IMG_6852.png', 'https://cdn.magicpatterns.com/uploads/mpg51UV8u2xUAMvZRZWGkG/67bc2b68-2a89-4562-9fe8-91f1c70fbeaf.jpg', 'https://cdn.magicpatterns.com/uploads/wENQEcc21VHcisySE2Fndf/558a4435-eb5b-47c9-b7e5-047b1a9b0aff.jpg', 'https://cdn.magicpatterns.com/uploads/bcb67oHn2wPijg5nutKmzy/b02ffbc3-d4d2-40c9-a9e8-d7869755e6b1.jpg', 'https://cdn.magicpatterns.com/uploads/jQEbLwmgWdwGTcCsWjtS9m/IMG_0088.jpg', 'https://cdn.magicpatterns.com/uploads/prmNDGwM7aLwkwofcUjXw3/IMG_1439.jpg', 'https://cdn.magicpatterns.com/uploads/g9DumC9otmbLdw2HUMGx6P/IMG_3441.jpg', 'https://cdn.magicpatterns.com/uploads/6yqb3jdQM92cXXSxcUkV4U/IMG_3862.jpg', 'https://cdn.magicpatterns.com/uploads/wNGXWgMutpmXyoAmNYVtHC/IMG_5343.jpg', 'https://cdn.magicpatterns.com/uploads/jyq44hzPhJpD4146pS3D2m/IMG_5399.jpg', 'https://cdn.magicpatterns.com/uploads/8BBz7kUrkpQwejbFs6juZs/IMG_6855.png'];
function EventPhoto({
  src,
  index,
  height,
  onOpen
}: {
  src: string | null;
  index: number;
  height: number;
  onOpen: (index: number) => void;
}) {
  if (src) {
    return <div className="w-full overflow-hidden cursor-pointer" style={{
      height: `${height}px`,
      borderRadius: '12px',
      flexShrink: 0
    }} onClick={() => onOpen(index)} role="button" tabIndex={0} aria-label={`Ampliar foto del evento ${index + 1}`} onKeyDown={e => {
      if (e.key === 'Enter' || e.key === ' ') onOpen(index);
    }} data-id="element-31" data-mp="1wjc1eyv5oxrt">
        <img src={src} alt={`Foto del evento ${index + 1}`} className="transition-[filter] duration-200 hover:brightness-105" style={{
        width: '100%',
        height: `${height}px`,
        objectFit: 'cover',
        objectPosition: 'center top',
        display: 'block',
        borderRadius: '12px'
      }} data-id="element-32" data-mp="2ai1ywflw0zgp" />
      </div>;
  }
  return <div className="w-full flex flex-col items-center justify-center gap-2" style={{
    height: `${height}px`,
    borderRadius: '12px',
    flexShrink: 0,
    background: 'linear-gradient(135deg, #f0f7e6 0%, #d4edaa 100%)'
  }} data-id="element-33" data-mp="q0vy6cip8aud">
      <CameraIcon size={40} color="#7DC920" data-id="element-34" data-mp="3aq8qyd2iowz1" />
      <span style={{
      fontSize: '13px',
      color: '#7DC920'
    }} data-id="element-35" data-mp="3ap74lcg1wo20">
        Foto del evento {index + 1}
      </span>
    </div>;
}
export function EventsSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [perView, setPerView] = useState(3);
  const [isPaused, setIsPaused] = useState(false);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const isMobile = perView === 1;
  const photoHeight = isMobile ? 260 : 280;
  // Track viewport to switch between 3-per-view (desktop) and 1-per-view (mobile)
  useEffect(() => {
    const update = () => setPerView(window.innerWidth < 768 ? 1 : 3);
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);
  const totalSlides = Math.ceil(EVENT_PHOTOS.length / perView);
  // Clamp current slide when perView changes
  useEffect(() => {
    setCurrentSlide(prev => Math.min(prev, totalSlides - 1));
  }, [totalSlides]);
  // Auto-advance every 4s, paused on hover or when lightbox is open
  useEffect(() => {
    if (isPaused || lightboxOpen) return;
    const id = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % totalSlides);
    }, 4000);
    return () => clearInterval(id);
  }, [isPaused, lightboxOpen, totalSlides]);
  const goPrev = () => setCurrentSlide(prev => (prev - 1 + totalSlides) % totalSlides);
  const goNext = () => setCurrentSlide(prev => (prev + 1) % totalSlides);
  const openLightbox = (index: number) => {
    setLightboxIndex(index);
    setLightboxOpen(true);
  };
  const closeLightbox = () => setLightboxOpen(false);
  const lightboxPrev = () => setLightboxIndex(prev => (prev - 1 + EVENT_PHOTOS.length) % EVENT_PHOTOS.length);
  const lightboxNext = () => setLightboxIndex(prev => (prev + 1) % EVENT_PHOTOS.length);
  // Keyboard controls for lightbox
  useEffect(() => {
    if (!lightboxOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') closeLightbox();else if (e.key === 'ArrowLeft') lightboxPrev();else if (e.key === 'ArrowRight') lightboxNext();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [lightboxOpen]);
  const lightboxSrc = EVENT_PHOTOS[lightboxIndex];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-36" data-mp="2nnodyezv4keb">
      <div className="max-w-6xl mx-auto" data-id="element-37" data-mp="2rprsxdlqq74c">
        <div className="text-center mb-12" data-id="element-38" data-mp="2rogorcoduxcp">
          <p style={{
          fontSize: '13px',
          color: '#7DC920',
          letterSpacing: '3px',
          fontWeight: 600,
          textTransform: 'uppercase',
          marginBottom: '8px'
        }} data-id="element-39" data-mp="1c9avjpnvox5o">
            Nuestro Impacto en Acción
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold text-dark" data-id="element-40" data-mp="3dxxad3waziu0">
            Galería de Eventos
          </h2>
          <p className="mx-auto mt-4 max-w-xl" style={{
          fontSize: '16px',
          color: '#666',
          textAlign: 'center'
        }} data-id="element-41" data-mp="396oxtyzofhcm">
            Momentos reales de nuestra comunidad y eventos realizados
          </p>
        </div>

        {/* Carousel */}
        <div className="relative mx-auto" style={{
        maxWidth: '900px'
      }} onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} data-id="element-42" data-mp="2v6nwyjjew9x5">
          <div style={{
          width: '100%',
          position: 'relative',
          overflow: 'hidden',
          borderRadius: '16px'
        }} data-id="element-43" data-mp="2lc5s3b29e8br">
            <div className="flex" style={{
            transform: `translateX(-${currentSlide * 100}%)`,
            transition: 'transform 0.5s ease'
          }} data-id="element-44" data-mp="jglol6qaok4d">
              {Array.from({
              length: totalSlides
            }).map((_, slideIdx) => {
              const start = slideIdx * perView;
              const slidePhotos = EVENT_PHOTOS.slice(start, start + perView);
              return <div key={slideIdx} className="shrink-0 box-border px-1" style={{
                width: '100%'
              }} data-id="element-45" data-mp="92e1f6k1mpes" data-mpi={slideIdx}>
                    <div className="grid items-stretch" style={{
                  gridTemplateColumns: `repeat(${perView}, 1fr)`,
                  gap: '16px'
                }} data-id="element-46" data-mp="n0cco332i5q2">
                      {slidePhotos.map((src, i) => <EventPhoto key={start + i} src={src} index={start + i} height={photoHeight} onOpen={openLightbox} data-id="element-47" data-mp="2jj1sf0z5fhh0" data-mpi={i} />)}
                    </div>
                  </div>;
            })}
            </div>
          </div>

          {/* Arrows */}
          <button type="button" aria-label="Anterior" onClick={goPrev} className="absolute top-1/2 flex items-center justify-center text-dark transition-colors hover:bg-primary hover:text-white" style={{
          left: '-20px',
          transform: 'translateY(-50%)',
          background: 'white',
          border: 'none',
          borderRadius: '50%',
          width: '48px',
          height: '48px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          cursor: 'pointer',
          zIndex: 10
        }} data-id="element-48" data-mp="335zidfmwanri">
            <ChevronLeftIcon size={24} data-id="element-49" data-mp="3th9wgruux6xw" />
          </button>
          <button type="button" aria-label="Siguiente" onClick={goNext} className="absolute top-1/2 flex items-center justify-center text-dark transition-colors hover:bg-primary hover:text-white" style={{
          right: '-20px',
          transform: 'translateY(-50%)',
          background: 'white',
          border: 'none',
          borderRadius: '50%',
          width: '48px',
          height: '48px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          cursor: 'pointer',
          zIndex: 10
        }} data-id="element-50" data-mp="3tgrr95q7vidu">
            <ChevronRightIcon size={24} data-id="element-51" data-mp="v07179rjl3ee" />
          </button>
        </div>

        {/* Dots */}
        <div style={{
        marginTop: '24px',
        display: 'flex',
        justifyContent: 'center',
        gap: '8px'
      }} data-id="element-52" data-mp="z1iwnvx3kiui">
          {Array.from({
          length: totalSlides
        }).map((_, i) => {
          const active = i === currentSlide;
          return <button key={i} type="button" aria-label={`Ir a la diapositiva ${i + 1}`} onClick={() => setCurrentSlide(i)} style={{
            width: active ? '24px' : '8px',
            height: '8px',
            borderRadius: active ? '4px' : '50%',
            background: active ? '#7DC920' : '#ddd',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
            transition: 'all 0.3s'
          }} data-id="element-53" data-mp="1wgriz98thnmr" data-mpi={i} />;
        })}
        </div>

        <p style={{
        fontSize: '13px',
        color: '#999',
        textAlign: 'center',
        marginTop: '16px'
      }} data-id="element-54" data-mp="14n8zcb7ox7ib">
          📸 Próximamente más fotos de nuestros eventos
        </p>
      </div>

      {/* Lightbox */}
      {lightboxOpen && lightboxSrc && <div onClick={closeLightbox} style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      background: 'rgba(0, 0, 0, 0.92)',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer'
    }} data-id="element-55" data-mp="w9w76b2tkqcf">
          {/* Close */}
          <button type="button" aria-label="Cerrar" onClick={e => {
        e.stopPropagation();
        closeLightbox();
      }} className="mp-lb-btn" style={{
        position: 'absolute',
        top: '20px',
        right: '24px',
        color: 'white',
        background: 'rgba(255,255,255,0.15)',
        border: 'none',
        borderRadius: '50%',
        width: '44px',
        height: '44px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer'
      }} data-id="element-56" data-mp="s6zvz5flzwii">
            <XIcon size={28} data-id="element-57" data-mp="y51p1nz1m2g1" />
          </button>

          {/* Prev */}
          <button type="button" aria-label="Foto anterior" onClick={e => {
        e.stopPropagation();
        lightboxPrev();
      }} className="mp-lb-arrow" style={{
        position: 'absolute',
        left: '16px',
        top: '50%',
        transform: 'translateY(-50%)',
        background: 'rgba(255,255,255,0.15)',
        border: 'none',
        borderRadius: '50%',
        width: '48px',
        height: '48px',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer'
      }} data-id="element-58" data-mp="1gc39mkaopos">
            <ChevronLeftIcon size={26} data-id="element-59" data-mp="36fsz8gm96ut6" />
          </button>

          {/* Image */}
          <img src={lightboxSrc} alt={`Foto del evento ${lightboxIndex + 1}`} onClick={e => e.stopPropagation()} style={{
        maxWidth: '90vw',
        maxHeight: '85vh',
        objectFit: 'contain',
        borderRadius: '12px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
        cursor: 'default'
      }} data-id="element-60" data-mp="31lf0q5cao7ka" />

          {/* Next */}
          <button type="button" aria-label="Foto siguiente" onClick={e => {
        e.stopPropagation();
        lightboxNext();
      }} className="mp-lb-arrow" style={{
        position: 'absolute',
        right: '16px',
        top: '50%',
        transform: 'translateY(-50%)',
        background: 'rgba(255,255,255,0.15)',
        border: 'none',
        borderRadius: '50%',
        width: '48px',
        height: '48px',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer'
      }} data-id="element-61" data-mp="2dpan6q3jxj3m">
            <ChevronRightIcon size={26} data-id="element-62" data-mp="16ktzmjezt4a" />
          </button>

          {/* Counter */}
          <div style={{
        position: 'absolute',
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        color: 'white',
        fontSize: '14px',
        background: 'rgba(0,0,0,0.5)',
        padding: '6px 16px',
        borderRadius: '20px'
      }} data-id="element-63" data-mp="605i8mv7h8qa">
            {lightboxIndex + 1} / {EVENT_PHOTOS.length}
          </div>
        </div>}
    </section>;
}